/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormLabel, Input, InputProps } from '@chakra-ui/react';
import { useField, useFormState } from 'react-final-form';
import styled from '@emotion/styled';
import { get } from 'lodash-es';
import { FormValues } from 'types';
import { Control, MetaError } from './Control';

const InputStyled = styled(Input)`
  height: 32px;
  border: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;

  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.asphalt[1]};
    font-size: 14px;
  }
`;

const InputControl: React.FC<
  InputProps & {
    name: string;
    label?: string;
    mask?: Array<RegExp | string>;
  } & any
> = React.forwardRef(
  ({ className, name, label, placeholder, ...rest }, ref) => {
    const { input } = useField(name);
    const { touched, errors } = useFormState<FormValues>();

    const isTouched = get(touched, name);
    const error = get(errors, name);

    return (
      <Control name={name} my={4} className={className}>
        {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
        <InputStyled
          {...input}
          {...rest}
          isInvalid={error && isTouched}
          id={name}
          placeholder={placeholder}
          ref={ref}
        />
        <MetaError name={name} />
      </Control>
    );
  },
);

export { InputControl as Input };
